export enum ModalKeys {
    CREATE = 'create',
    DELETE = 'delete',
    UPDATE_OWNERS = 'updateOwners',
    UPDATE_TAGS = 'updateTags',
    UPDATE_TERMS = 'updateTerms',
    UPDATE_DOMAIN = 'updateDomain',
}
